import { GroupedListData } from 'modules/analytics/common/types';
import { sumScoreField } from 'modules/analytics/common/utils';
import { npsScore } from 'modules/analytics/survey/utils/survey-scores';
import SurveyRateCell from 'modules/survey/management/components/SurveyRateCell/SurveyRateCell';

const NpsScoreCell = ({ data }: { data: GroupedListData }) => {
  const promotersTotal = data.isGroup ? sumScoreField(data?.scoreData || [], 'promotersTotal') : data.promotersTotal;
  const detractorsTotal = data.isGroup ? sumScoreField(data?.scoreData || [], 'detractorsTotal') : data.detractorsTotal;
  const npsTotal = data.isGroup ? sumScoreField(data?.scoreData || [], 'npsTotal') : data.npsTotal;

  return <SurveyRateCell key={data._id} number={npsScore(promotersTotal || 0, detractorsTotal || 0, npsTotal || 0)} />;
};

export default NpsScoreCell;
